import { GLOBAL_TOOLBAR_HEIGHT_NUMBER } from 'nav-meta/constants';
import { isInIframe } from '../../overlayDisplayConfig/utils/isInIframe';
import { HS_NAV_CONTAINER_ID } from '../constants';
import { getExternalBannersHeight } from './getExternalBannersHeight';
export function getNavHeight(isAcademyNav) {
  if (isInIframe() && !isAcademyNav) {
    return 0;
  }
  const hasStickyToolbar = document.body.classList.contains('sticky-global-toolbar');
  if (hasStickyToolbar) {
    let totalHeight = getExternalBannersHeight();
    const navElement = document.getElementById(HS_NAV_CONTAINER_ID);
    totalHeight += navElement ? navElement.getBoundingClientRect().height : 0;
    return totalHeight;
  }
  const navElement = document.getElementById(HS_NAV_CONTAINER_ID);
  const {
    scrollY
  } = window;
  const navElementBottom = navElement ? navElement.getBoundingClientRect().bottom + scrollY : GLOBAL_TOOLBAR_HEIGHT_NUMBER;
  return navElementBottom;
}